export enum Site {
  Green = "Green",
  Blue = "Blue",
}
